import React from 'react';
import Icon from '../../../components/AppIcon';

const WhyDifferentSection = () => {
  const differentiators = [
    {
      icon: 'Users',
      title: 'Designed for Real-Life Finances',
      description: 'Built for how you actually manage money—not just numbers in a spreadsheet. Track what matters to you.'
    },
    {
      icon: 'Layout',
      title: 'Clean Views, Not Cluttered Tables',
      description: 'See your financial picture at a glance with intuitive dashboards and visual insights that make sense.'
    },
    {
      icon: 'Smartphone',
      title: 'Mobile-Friendly by Design',
      description: 'Manage your budget on any device. Responsive design means you can check your finances anywhere, anytime.'
    },
    {
      icon: 'Layers',
      title: 'Simple for Beginners, Powerful for Experts',
      description: 'Start with basic tracking and unlock advanced features as you grow. The platform adapts to your needs.'
    },
    {
      icon: 'TrendingUp',
      title: 'Built to Grow With You',
      description: 'From your first budget to complex financial planning, Rovyn Budget scales with your financial journey.'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-card">
      <div className="mx-auto px-4 md:px-6 lg:px-24 max-w-7xl">
        <div className="text-center mb-10 md:mb-14 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-card-foreground mb-3 md:mb-4">
            Why Rovyn Budget Is Different
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            We're not just another budgeting tool—we're your financial companion
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 lg:gap-8">
          {differentiators?.map((item, index) => (
            <div
              key={index}
              className="bg-background rounded-xl md:rounded-2xl p-5 md:p-6 lg:p-7 hover:shadow-elevation-3 transition-smooth"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-xl mb-4">
                <Icon name={item?.icon} size={24} color="var(--color-primary)" strokeWidth={2} />
              </div>
              <h3 className="text-base md:text-lg lg:text-xl font-heading font-semibold text-card-foreground mb-2 md:mb-3">
                {item?.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {item?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyDifferentSection;